/**
 * Daty terminów przeglądu — lustro reguły backendu (backend/src/utils/termDate.js, fix/term-date-validation):
 * rok w zakresie [bieżący − 1, bieżący + 2]. `<input type="date">` przyjmuje rok 0002 (w Chrome rok
 * wpisuje się cyfra po cyfrze), więc pola dostają min/max i komunikat, a przycisk zapisu jest wyłączony.
 * Backend i tak odrzuci 400 INVALID_TERM_DATE — to tylko wcześniejsza informacja dla operatora.
 */
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function termYearRange(now: Date = new Date()): { min: number; max: number } {
  const y = now.getFullYear();
  return { min: y - 1, max: y + 2 };
}

export function termDateBounds(now: Date = new Date()): { min: string; max: string } {
  const { min, max } = termYearRange(now);
  return { min: `${min}-01-01`, max: `${max}-12-31` };
}

/** null gdy poprawna (albo pusta); inaczej komunikat pod polem. */
export function termDateError(value: string | null | undefined, now: Date = new Date()): string | null {
  if (!value) return null;
  const m = ISO_DAY.exec(value);
  if (!m) return 'Nieprawidłowa data — wpisz pełną datę';
  const y = Number(m[1]); const mo = Number(m[2]); const d = Number(m[3]);
  // Najpierw rok (Date.UTC mapuje lata 0–99 na 1900+, więc kalendarz sprawdzamy dopiero w zakresie).
  const { min, max } = termYearRange(now);
  if (y < min || y > max) return `Sprawdź rok — wpisz pełną datę, np. 10.07.${now.getFullYear()} (dozwolone lata ${min}–${max})`;
  const probe = new Date(Date.UTC(y, mo - 1, d));
  if (probe.getUTCFullYear() !== y || probe.getUTCMonth() !== mo - 1 || probe.getUTCDate() !== d) {
    return 'Taka data nie istnieje w kalendarzu';
  }
  return null;
}
